// 自主测试API
import apiClient, { API_ENDPOINTS } from "@/config/api";

export class SelfTestAPI {
  /**
   * 获取测试题目
   */
  static async getQuestions(params = {}) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SELF_TEST.GET_QUESTIONS, {
        test_types: params.testTypes || ['en_to_cn'],
        difficulty: params.difficulty || 'easy',
        limit: params.limit || 10
      });
      // 检查响应格式，确保返回正确的结构
      if (Array.isArray(response)) {
        // 如果拦截器返回的是数组，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取题目成功"
        };
      } else if (response && response.success !== undefined) {
        // 如果已经是标准格式，直接返回
        return response;
      } else {
        // 其他情况，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取题目成功"
        };
      }
    } catch (error) {
      console.error("获取题目失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取题目失败",
      };
    }
  }

  /**
   * 提交测试结果
   */
  static async submitTest(testData) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SELF_TEST.SUBMIT_TEST, testData);
      // 检查响应格式，确保返回正确的结构
      if (response && response.success !== undefined) {
        // 如果已经是标准格式，直接返回
        return response;
      } else {
        // 其他情况，包装成标准格式
        return {
          success: true,
          data: response,
          message: "提交测试结果成功"
        };
      }
    } catch (error) {
      console.error("提交测试结果失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "提交测试结果失败",
      };
    }
  }

  /**
   * 获取测试记录
   */
  static async getTestRecords(params = {}) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SELF_TEST.GET_RECORDS, {
        params: {
          page: params.page || 1,
          limit: params.limit || 10
        }
      });
      // API拦截器已经处理了响应格式，直接返回
      return response;
    } catch (error) {
      console.error("获取测试记录失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取测试记录失败",
      };
    }
  }

  /**
   * 获取测试统计
   */
  static async getTestStats() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SELF_TEST.GET_STATS);
      // API拦截器已经处理了响应格式，直接返回
      return response;
    } catch (error) {
      console.error("获取测试统计失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取测试统计失败",
      };
    }
  }
}

export default SelfTestAPI;
